import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import FilterView from './FilterView';
import SubcriptionsView from './SubcriptionsView';
import crmservices from '../../wsclient/crmservices';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { getAppCfg, getCurrency } from '../../utils/common';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import ProductsView from './ProductsView';
import CardsView from './CardsView';
import ModalConfirm from '../../components/ModalConfirm';
import { formatDateTimeFrEpoch, formatDateToDDMMYYYYFrEpoch } from '../../utils/util';
import FormServiceChange from './FormServiceChange';
import { crocottservices } from '../../wsclient/crmservices/crocottservices';
import DevicesView from './DevicesView';
import { portal_config } from '../../../portal.config';

const styles = theme => ({

});

function Subcriptions(props) {
    const { t } = props;
    const [openFilter, setOpenFilter] = useState(false);
    const [filter_options, setFilterOptions] = useState(null);
    const [filterSelected, setFilterSelected] = useState(1);

    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [showLoading, onShowLoading] = useState(false);
    const [periodSelected, setPeriodSelected] = useState(null);
    const [periods, setPeriod] = useState([]);
    const [subcriptions, setSubcriptions] = useState(null);
    const [mainLoading, onMainLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [listProducts, setListProducts] = useState([]);
    const [pagingProducts, setPagingProducts] = useState(null);
    const [hasMoreProducts, setHasMoreProducts] = useState(true);
    const [showLoadMoreProducts, onShowLoadMoreProducts] = useState(false);
    const [showProductsView, setShowProductsView] = useState(false);
    const [serviceSelected, setServiceSelected] = useState(null);
    const [subscriptionSeleted, setSubscriptionSelected] = useState(null);
    const [cards, setCards] = useState([]);
    const [showCardsView, setShowCardsView] = useState(false);
    const [devices, setDevices] = useState([])
    const [confirm, setConfirm] = useState({});
    const [showFormServiceChange, setShowFormServiceChange] = useState({
        show: false,
        message: null,
    });
    const [crocOTTDevices, setCrocOTTDevices] = useState([]);
    const [showDevices, setShowDevices] = useState(false);
    const [productsOTT, setProductsOTT] = useState([]);

    //     "state": "USED",
    //     "ownership": "OWNED_BY_CUSTOMER",
    //     "product": {
    //         "id": "4b099ef1-54a3-42d8-be86-298cc5d67a19",
    //         "name": "Calix 813G",
    //         "sku": "Calix 813G"
    //     },
    //     "subscription": {
    //         "id": "9d54b9a6-3e07-4d6d-b5eb-68ee5cf5849e",
    //         "code": "8085638521233634"
    //     },
    //     "provisioning": {
    //         "id": "4c4d857f-aafb-43f6-bc5e-35e72de7a229",
    //         "name": "Test Provider"
    //     },
    //     "id": "6b6f6130-b447-4d5f-b0c8-9d6c00748f40",
    //     "serial_number": "44-65-7F-2F-27-10",
    //     "provided_on": 1650595382,
    //     "enabled_services": [
    //         {
    //             "product": {
    //                 "id": "58e675e4-b00e-486b-8952-4094c06bcd76",
    //                 "name": "Basic HD",
    //                 "sku": "Basic HD"
    //             },
    //             "id": "9621a18a-2413-485c-81a8-2e801b5a110d",
    //             "life_cycle_state": "DRAFT"
    //         }
    //     ],
    //     "custom_fields": null
    // },
    //     {
    //         "state": "RENTED",
    //         "ownership": "OWNED_BY_BUSINESS",
    //         "product": {
    //             "id": "34b2bc46-f856-4a88-a09b-27cd9878c36b",
    //             "name": "DTH-SMC",
    //             "sku": "DTH-SMC"
    //         },
    //         "subscription": {
    //             "id": "7b342e44-128a-4a06-b4f3-6cacc1b1647f",
    //             "code": "8035487425463357"
    //         },
    //         "provisioning": {
    //             "id": "4c4d857f-aafb-43f6-bc5e-35e72de7a229",
    //             "name": "Simulate Colable Provider"
    //         },
    //         "id": "da456263-0b01-424d-9e0f-29d05c4ee02e",
    //         "serial_number": "805350000000019",
    //         "provided_on": 1652686797,
    //         "enabled_services": [
    //             {
    //                 "product": {
    //                     "id": "58e675e4-b00e-486b-8952-4094c06bcd76",
    //                     "name": "Basic HD",
    //                     "sku": "Basic HD"
    //                 },
    //                 "id": "a54e327d-8146-47b5-ac7c-27a6e2071bd9",
    //                 "life_cycle_state": "EFFECTIVE"
    //             }
    //         ],
    //         "custom_fields": null
    //     }])

    useEffect(() => {
        onInit();
    }, []);

    const onInit = async () => {
        let data = await onLoadSubcriptions();
        console.log('onLoadSubcriptions data: ', data)
        if (data && data.length > 0) {
            let periodData = dataUtil.groupBillingPeriod(data);
            if (periodData && periodData.length > 0) {
                setPeriodSelected(periodData[0]);
            }
        }
        await getProductsOTT();
    }

    const getProductsOTT = async () => {
        try {
            const appConfig = getAppCfg();
            const crocOTT = appConfig?.features?.ordering_details?.order_catalogs?.find(x => x.name && x.name.toLowerCase() == portal_config.order_catalog) || null;
            let result = await crmservices.products.getProductsCatalogue({
                order_catalog_id: crocOTT.id,
            })
            if (result.code == 'OK' && result.data) {
                setProductsOTT(result.data.content)
            }
        } catch (error) {
            console.log("AAAAA getProductsOTT error: ", error)
        }
    }

    const onChangeTab = (period) => {
        setPeriodSelected(period);
    }

    const onLoadSubcriptions = async (isRefresh) => {
        onShowLoading(isRefresh ? false : true);
        var subscriptionServices = [];
        var isLoadedDevice = false;
        var _devices = [];
        try {
            const result = await crmservices.contacts.getListContactServices({include_subscription: true});
            console.log("onLoadSubcriptions result:", result);
            if (result.code == 'OK') {
                let data = result.data.content ? result.data.content : []
                for (let i = 0; i < data.length; i++) {
                    let subscriptionService = data[i];
                    let product = subscriptionService.service ? subscriptionService.service.product : null;
                    if (product) {
                        let info = await crmservices.orders.getProductDetail(product.id);
                        console.log("product info:", info);
                        if (info.code == 'OK') {
                            console.log("info.data.creatives:", info.data.creatives);
                            product.creatives = info.data.creatives;
                        }
                    }
                    console.log("subscriptionService:", subscriptionService);
                    if (!isLoadedDevice && subscriptionService.service.life_cycle_state && subscriptionService.service.life_cycle_state == 'EFFECTIVE'){
                        const resultDevice = await crmservices.contacts.getListServiceDevices({ service_id: subscriptionService.service.id });
                        console.log("resultDevice:", resultDevice);
                        if (resultDevice.code == 'OK' && resultDevice.data && resultDevice.data.content && resultDevice.data.content.length > 0){
                            resultDevice.data.content.map((device)=>{
                                _devices.push(device)
                            })
                        }
                        
                    }
                    subscriptionServices.push(subscriptionService);
                }
            }
            console.log("subscriptionServices:", subscriptionServices);
            setDevices(_devices);
            setSubcriptions(dataUtil.groupServicesByMonth(subscriptionServices));
            setPeriod(dataUtil.groupBillingPeriod(subscriptionServices));
        } catch (ex) {
            console.log("on load subscription ex:", ex);
        }
        onShowLoading(false);
        return subscriptionServices;
    }
   
    const onCloseFilter = () => {
        setOpenFilter(false);
    }

    const onOpenFilter = () => {
        setOpenFilter(true);
    }

    const handleLoadMore = () => {

    }

    const onUpgradeOld = async (service) => {
        try {
            if (service) {
                setServiceSelected(service);
                let prodId = service.product && service.product.id ? service.product.id : null;
                let products = await onLoadProductsTier(prodId);
                if (products && products.length > 0)
                    setShowProductsView(true);
                else{
                    showAlert('WARNING', t('no_available_upgrade_service'));
                }
            }
        }
        catch (ex) {
            console.log("onUpgrade exception==", ex);
        }
    }

    const onUpgrade = async (service) => {
        try {
            if (service) {
                setServiceSelected(service)
                let result = await crmservices.subscriptions.getServiceRecommendation({
                    size: 100,
                    service_id: service.id,
                    include_creatives: true,
                })
                if (result.code == 'OK' && result.data) {
                    let products = result.data?.content || [];
                    let _newProducts = [];
                    if (products && products.length > 0 && service.price) {
                        console.log("AAAA service.price: ", service.price)
                        products.forEach(element => {
                            let _prices = element?.prices?.filter(x => x.id != service.price.id);
                            console.log("AAAA _prices: ", _prices)
                            if (_prices && _prices.length > 0) {
                                _newProducts.push({ ...element, prices: _prices });
                            }
                        });
                    }
                    setListProducts(_newProducts)
                    if (_newProducts && _newProducts.length > 0) setShowProductsView(true);
                    else {
                        showAlert('WARNING', t('no_available_upgrade_service'));
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onUpgrade error: ", error)
        }
    }

    const onLoadProductsTier = async (prodId) => {
        let products = [];
        onMainLoading(true);
        try {
            let params = {};
            params.prodId = prodId;
            params.change_type = 'UPGRADE';

            const result = await crmservices.products.getProductsTier({ ...params });
            console.log("result getProductsTier1===", result);
            if (result.code == 'OK') {
                products = result.data && result.data.content ? result.data.content : [];
                setListProducts(products);
                setPagingProducts(result.data.paging);
                if (result.data.content.length === 0)
                    setHasMoreProducts(false);
            } else {
                setError({
                    showAlert: true,
                    title: 'ERROR',
                    message: t('EXCEPTION_PROCESS'),
                    status: t('ERROR'),
                });
            }
        } catch (ex) {
            console.log("on getProductsTier ex:", ex);
        }
        onMainLoading(false);
        return products;
    }

    const handleLoadMoreProductsTier = async () => {
        let params = { ...pagingProducts };
        params.page = params.page + 1;
        params.prodId = serviceSelected && serviceSelected.product && serviceSelected.product.id ? serviceSelected.product.id : null;
        params.change_type = 'UPGRADE';

        try {
            onShowLoadMoreProducts(true);
            try {
                let result = await crmservices.products.getProductsTier({ ...params });
                console.log('getProductsTier load more== ', result)
                if (result.code === 'OK') {
                    let new_products = result.data && result.data.content ? result.data.content : [];
                    setListProducts([...listProducts, ...new_products]);
                    setPagingProducts(result.data.paging);

                    if (result.data.content.length === 0)
                        setHasMoreProducts(false);
                }
            } catch (error) {
                console.log("getProductsTier exception:", error);
            }
            onShowLoadMore(false);
        } catch (error) {
            console.log("getProductsTier Load More Exception:", error);
        }
    }

    const onUpdateService = async (action, service_id, prodId, priceId) => {
        onShowLoading(true);
        setConfirm({});
        setShowProductsView(false);
        try {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            let body = {};
            if (action === 'PAUSE') {
                body = {
                    action: action,
                    number_of_days: 1,
                    use_proposed_date: false,
                    // scheduled_date: Math.floor(tomorrow.getTime() / 1000.0),
                }
            }
            else {
                body = {
                    action: (action === 'UPGRADE' || action === 'DOWNGRADE') ? 'CHANGE' : action,
                    change_to_service: {
                        product_id: prodId,
                        price_terms_id: priceId,
                    },
                    use_proposed_date: false,
                };
            }
            const result = await crmservices.contacts.onUpdateServiceWithBody(service_id, body);
            console.log("result onUpdateService===", result);
            if (result.code == 'OK') {
                let proposed_scheduled_date = null;
                if (result.data && result.data.proposed_scheduled_date) {
                    proposed_scheduled_date = formatDateToDDMMYYYYFrEpoch(result.data.proposed_scheduled_date, true);
                }
                if(proposed_scheduled_date){
                    let mess = null;
                    if(action === 'UPGRADE') mess = t('confirm_upgrade_service_success_with_date');
                    else if(action === 'DOWNGRADE') mess  = t('confirm_down_service_success_with_date');
                    else if(action === 'CANCEL') mess  = t('confirm_cancel_service_success_with_date');
                    else if(action === 'PAUSE') mess  = t('confirm_pause_service_success_with_date');
                    else if(action === 'RESUME') mess  = t('confirm_resume_service_success_with_date');
                    else if(action === 'ACTIVATE') mess  = t('confirm_active_service_success_with_date');

                    setConfirm({
                        show: true,
                        message: mess + proposed_scheduled_date + "?",
                        actionTitle: t('yes'),
                        cancelTitle: t('no'),
                        onAction: () => onUpdateChangeServiceWithProposeDate(action, service_id, prodId, priceId, proposed_scheduled_date)
                    });
                }else{
                    let mess = null;
                    if(action === 'UPGRADE') mess = t('upgrade_service_success');
                    else if(action === 'DOWNGRADE') mess = t('down_service_success');
                    else if(action === 'CANCEL') mess = t('cancel_service_success');
                    else if(action === 'PAUSE') mess = t('pause_service_success');
                    else if(action === 'RESUME') mess = t('resume_service_success');
                    else if(action === 'ACTIVATE') mess = t('active_service_success');

                    showAlert('SUCCESS', mess);
                    if (!proposed_scheduled_date) await onInit();
                }
            } else {                
                let mess = null;
                let parameters = result?.data?.parameters?.join(',') || null;
                if(result.data && result.data.message){
                    mess = result.data.message;
                }
                else if(action === 'UPGRADE') mess = t('upgrade_service_failed');
                else if(action === 'DOWNGRADE') mess = t('down_service_failed');
                else if(action === 'CANCEL') mess = t('cancel_service_failed');
                else if(action === 'PAUSE') mess = t('pause_service_failed');
                else if(action === 'RESUME') mess = t('resume_service_failed');
                else if(action === 'ACTIVATE') mess = t('active_service_failed');
                else mess = t('EXCEPTION_PROCESS');

                // showAlert('ERROR', mess);
                setShowFormServiceChange({ show: true, message: mess, content: parameters })
            }
        } catch (ex) {
            console.log("onUpdateService ex:", ex);
        }
        onShowLoading(false);
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        onMainLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }

    const showAlert = async (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }

    const onUpdateSubscription = async (card) => {
        onShowLoading(true);
        try{
            
            let result = await crmservices.contacts.onUpdateSubscription('CHANGE_PAYMENT_METHOD', subscriptionSeleted && subscriptionSeleted.subscription && subscriptionSeleted.subscription.id ? subscriptionSeleted.subscription.id : null, card && card.id ? card.id : null);
            console.log("onUpdateSubscription result==", result);
            if(result.code == 'OK'){
                await onLoadSubcriptions();
                setShowCardsView(false);
                showAlert('SUCCESS', t('update_subscription_success'));
            }
            else if (result.data && result.data.error && result.data.error == 'CRM.EXCEPTIONS.MANDATORYFIELDEXCEPTION' ){
                showAlert('ERROR', t('card_is_already_selected'));
            }
            else{
                showAlert('ERROR', t('update_subscription_faild'));
            }
        }catch(ex){
            console.log("onRecurringPayment exception:", error);
        }
        onShowLoading(false);
    }

    const onConfirmChangeService = (product) => {
        let currentPrice = serviceSelected?.price?.price || 0;
        let productPrice = product?.prices?.[0]?.price || 0;
        console.log("AAAAA currentPrice: ", currentPrice)
        console.log("AAAAA productPrice: ", productPrice)
        if (currentPrice <= productPrice) {
            product.change_type = 'UPGRADE';
            console.log("AAAA CASE UPGRADE OR CHANGE OTHER PACKAGE")
            setConfirm({
                show: true,
                message: t('confirm_change_service') + product.name + "?",
                actionTitle: t('yes'),
                cancelTitle: t('no'),
                onAction: () => onServiceDelivery(product)
            });
        } else {
            console.log("AAAA CASE DOWNGRADE PACKAGE")
            setShowFormServiceChange({ show: true })
        }
    }

    const onServiceDelivery = async (product) => {
        onShowLoading(true);
        setConfirm({});
        try {
            let action = product && product.change_type ? product.change_type : null;
            let service_id = serviceSelected && serviceSelected.id ? serviceSelected.id : null;
            let product_id = product.id;
            let subscription_id = subscriptionSeleted && subscriptionSeleted.id ? subscriptionSeleted.id : null;
            let price = product && product.prices && product.prices.length > 0 ? product.prices[0] : null;

            const result = await crmservices.contacts.onServiceDelivery({
                action: action,
                services_to_change: [{
                    from_service_id: service_id,
                    to_service_product_id: product_id,
                    to_price_terms_id: price && price.id ? price.id : null,
                }],
                subscription_id: subscription_id,
            });
            console.log("result onServiceDelivery===", result);
            if (result.code == 'OK') {
                await onUpdateService(action, serviceSelected && serviceSelected.id ? serviceSelected.id : null, product.id, price && price.id ? price.id : null);
            }
            else if (result.data && result.data.error && result.data.error == "FINANCE.EXCEPTIONS.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION"){
                // showAlert('ERROR', t('upgrade_service_faild_credit_limit'));
                setShowFormServiceChange({ show: true, message: t('upgrade_service_faild_credit_limit') })
            }
            else {
                // showAlert('ERROR', t('upgrade_service_faild'));
                setShowFormServiceChange({ show: true, message: t('upgrade_service_faild') })
            }
        } catch (ex) {
            console.log("on onServiceDelivery ex:", ex);
        }
        onShowLoading(false);
    }

    const onRecurringPayment = async(subscription) =>{
        onShowLoading(true);
        try {
            setSubscriptionSelected(subscription);
            let result = await crmservices.contacts.getListPaymentMethods();

            if (result.code == 'OK') {
                let paymentMethods = result.data.content;
                var payment_selected_id = subscription && subscription.subscription && subscription.subscription.terms && subscription.subscription.terms.payment_method && subscription.subscription.terms.payment_method.id ? subscription.subscription.terms.payment_method.id : null;
                if (paymentMethods.length && paymentMethods.length > 0 && payment_selected_id != null){
                    paymentMethods.map((method=>{
                        if (payment_selected_id == method.id){
                            method.is_recurring = true;
                           
                        }
                    }))
                }
                setCards(paymentMethods);
                setShowCardsView(true);
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
        onShowLoading(false);
    }

    const onUpdateChangeServiceWithProposeDate = async (action, service_id, prodId, priceId, proposed_scheduled_date) => {
        onShowLoading(true);
        setConfirm({});
        try {
            let body = {
                action: (action === 'UPGRADE' || action === 'DOWNGRADE') ? 'CHANGE' : action,
                change_to_service: {
                    product_id: prodId,
                    price_terms_id: priceId,
                },
                use_proposed_date: true,
            };
            const result = await crmservices.contacts.onUpdateServiceWithBody(service_id, body);
            console.log("result onUpdateService===", result);
            if (result.code == 'OK') {
                setShowProductsView(false);
                if(proposed_scheduled_date){
                    let mess = null;
                    if(action === 'UPGRADE') mess = t('upgrade_service_success_with_date');
                    else if(action === 'DOWNGRADE') mess  = t('down_service_success_with_date');
                    else if(action === 'CANCEL') mess  = t('cancel_service_success_with_date');
                    else if(action === 'PAUSE') mess  = t('pause_service_success_with_date');
                    else if(action === 'RESUME') mess  = t('resume_service_success_with_date');
                    else if(action === 'ACTIVATE') mess  = t('active_service_success_with_date');

                    showAlert('SUCCESS', mess + proposed_scheduled_date + ".");
                }else{
                    let mess = null;
                    if(action === 'UPGRADE') mess = t('upgrade_service_success');
                    else if(action === 'DOWNGRADE') mess = t('down_service_success');
                    else if(action === 'CANCEL') mess = t('cancel_service_success');
                    else if(action === 'PAUSE') mess = t('pause_service_success');
                    else if(action === 'RESUME') mess = t('resume_service_success');
                    else if(action === 'ACTIVATE') mess = t('active_service_success');

                    showAlert('SUCCESS', mess);
                }
                await onInit();
            } else {
                let mess = null;
                if(result.data && result.data.message){
                    mess = result.data.message;
                }
                else if(action === 'UPGRADE') mess = t('upgrade_service_failed');
                else if(action === 'DOWNGRADE') mess = t('down_service_failed');
                else if(action === 'CANCEL') mess = t('cancel_service_failed');
                else if(action === 'PAUSE') mess = t('pause_service_failed');
                else if(action === 'RESUME') mess = t('resume_service_failed');
                else if(action === 'ACTIVATE') mess = t('active_service_failed');
                else mess = t('EXCEPTION_PROCESS');

                showAlert('ERROR', mess);
            }
        } catch (ex) {
            console.log("update service exception===", ex);
        }
        onShowLoading(false);
    }

    const onCancelService = (item) => {
        setConfirm({
            show: true,
            message: "Are you sure you want to cancel this service?",
            actionTitle: t('yes'),
            cancelTitle: t('no'),
            onAction: () => handleCancelService(item)
        })
    }

    const handleCancelService = async (item) => {
        console.log("AAAA toam")
        setConfirm(null)
        try {
            let body = {
                id: item.service.id,
                action: "CANCEL",
            }
            if (document._portalConfig.isScheduleCancelService) {
                body.scheduled_date = item?.service?.terms?.termed_period?.end_date
            }
            let result = await crmservices.subscriptions.updateService(body)
            if (result.code == "OK") {
                onLoadSubcriptions()
                showAlert(true, t('cancel_service_success_schedule'));
            } else {
                showAlert(true, t('cancel_service_failed'))
            }
            console.log("AAA result", result)
        } catch (error) {
            console.log("Error")
            showAlert(true, t('EXCEPTION_PROCESS'))
        }
    };

    const onViewDevices = async () => {
        onMainLoading(true)
        try {
            let result = await crocottservices.getListDevices();
            if (result.code == 'OK' && result.data) {
                setCrocOTTDevices(result.data?.data?.devices || [])
                setShowDevices(true)
            }
        } catch (error) {
            console.log("AAAA onViewDevices error: ", error)
        }
        onMainLoading(false)
    }

    const onRemoveDevice = (device) => {
        setConfirm({
            show: true,
            message: "Are you sure you want to delete this device?",
            actionTitle: t('yes'),
            cancelTitle: t('no'),
            onAction: () => processRemoveDevice(device)
        })
    }

    const processRemoveDevice = async (device) => {
        setConfirm(null)
        onMainLoading(true)
        try {
            console.log("AAAA processRemoveDevice device: ", device)
            let result = await crocottservices.deleteDevice(device.id);
            if (result.code == 'OK') {
                onViewDevices();
                showAlert(true, 'Device is removed success.')
            } else {
                showAlert(true, 'Can not remove device.')
            }
        } catch (error) {
            showAlert(true, t('EXCEPTION_PROCESS'))
        }
        onMainLoading(false)
    }

    return (
        <div>
            <SubcriptionsView
                periods={periods}
                subcriptions={subcriptions}
                periodSelected={periodSelected}
                showLoading={showLoading}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                hasMoreProducts={hasMoreProducts}
                showLoadMoreProducts={showLoadMoreProducts}
                devices={devices}
                productsOTT={productsOTT}
                from={props.from}
                currency={getCurrency()}
                handleLoadMore={handleLoadMore}
                onOpenFilter={onOpenFilter}
                onChangeTab={onChangeTab}
                onUpgrade={onUpgrade}
                onRecurringPayment={onRecurringPayment}
                handleLoadMoreProductsTier={handleLoadMoreProductsTier}
                onCancelService={onCancelService}
                onViewDevices={onViewDevices}
            />
            {mainLoading && <Loading showLoading={mainLoading} />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message ? confirm.message : null}
                confirm={confirm.actionTitle ? confirm.actionTitle : null}
                buttonLabel={confirm.cancelTitle ? confirm.cancelTitle : null}
                onAction={confirm.onAction ? () => confirm.onAction() : null}
            />}
            {showProductsView && <ProductsView
                open={showProductsView}
                listProducts={listProducts}
                showLoading={showLoading}
                hasMore={hasMoreProducts}
                showLoadMore={showLoadMoreProducts}
                serviceSelected={serviceSelected}
                currency={getCurrency()}
                onClickDetail={onConfirmChangeService}
                handleLoadMore={handleLoadMoreProductsTier}
                onClose={() => setShowProductsView(false)}
            />}
            {showCardsView && <CardsView
                open={showCardsView}
                cards={cards}
                showLoading={showLoading}
                onClickDetail={onUpdateSubscription}
                onClose={() => setShowCardsView(false)}
            />}
            {showFormServiceChange && <FormServiceChange 
                open={showFormServiceChange.show}
                message={showFormServiceChange.message}
                content={showFormServiceChange.content}
                onClose={() => setShowFormServiceChange(false)}
                onCloseAfterSuccess={() => {
                    setShowFormServiceChange(false)
                    setShowProductsView(false)
                }}
            />}
            {showDevices && <DevicesView 
                open={showDevices}
                devices={crocOTTDevices}
                onClose={() => { setShowDevices(false); setCrocOTTDevices([]) }}
                onRemoveDevice={onRemoveDevice}
            />}
        </div>
    );
}

export default withStyles(styles)(withTranslation()(Subcriptions));